import { SPEditor } from '@gpeditor/plate-core';
import { moveListItems } from './moveListItems';

export const indentListItems = (editor: SPEditor) => {
  moveListItems(editor, true);
};
